// import React from "react";
// import DatePicker from "react-datepicker";
// import Required from "./Required";
// import { Label } from "reactstrap";
// import moment from "moment/moment";
// import { get } from "react-hook-form";

// const MyDate = ({
//   required,
//   disabled,
//   time,
//   format,
//   title,
//   name,
//   placeholder,
//   max,
//   min,
//   errors,
//   watch,
//   register,
//   trigger,
//   setValue,
//   year,
//   month,
// }) => {
//   const error = get(errors, name);
//     const isYearOnly = year === true;
//   const isMonthYear = month === true && !year;
//   console.log("Err",error,errors,typeof name);
  
//   return (
//     <div className="form-group my-2">
//       <Label htmlFor={name} className="form-label">
//         {title}
//         {title && required && <Required />}
//       </Label>
//       <div className="form-control-wrap">
//       <DatePicker
//           id={name}
//           className={`form-control ${error ? "is-invalid" : ""}`}
//           placeholderText={placeholder}
//           selected={watch(name)}
//           onChange={(date) => {
//             setValue(name, date);
//             trigger(name);
//           }}
//           dateFormat={
//             isYearOnly
//               ? "yyyy"
//               : isMonthYear
//               ? "MM/yyyy"
//               : format || "dd/MM/yyyy"
//           }
          
//           showYearPicker={isYearOnly}
//           showMonthYearPicker={isMonthYear}
//           showMonthDropdown={!isYearOnly && !isMonthYear}
//           showYearDropdown={!isYearOnly}
//           scrollableYearDropdown={!isYearOnly}
//           dropdownMode="select"
//           maxDate={max}
//           minDate={min}
//           showTimeInput={!isYearOnly && !isMonthYear && time}
//           disabled={disabled}
//            {...register(name, {
//             required: {
//               value: required,
//               message: `Please select ${title ||"this field"}`,
//             },
//           })}
//         />

//         {/* <DatePicker
//           id={name}
//           // className="form-control date-picker"
//           className={`form-control ${error ? "is-invalid" : ""}`}
//           placeholderText={placeholder}
//           {...register(name, {
//             required: {
//               value: required,
//               message: `Please select ${title}`,
//             },
//           })}
//           onChange={(date) => {
//             const formattedDate = moment(date).format("DD-MMM-YYYY"); // Format the date here
//             setValue(name, date); // Save the formatted date
//             trigger(name);
//           }}
//           selected={watch(name)}
//           dateFormat={format || "dd/MM/yyyy"}
//           maxDate={max}
//           minDate={min}
//           showYearDropdown
//           scrollableYearDropdown
//           dropdownMode="select"
//           // withPortal
//           // disabled={mode === "Edit" ? true : null}
//           showMonthDropdown
//           // yearDropdownItemNumber={12}
//           timeInputLabel="Time:"
//           showTimeInput={time}
//           disabled={disabled}
//         /> */}
//       </div>
//       {error && <p className="invalid">{error?.message}</p>}
//     </div>
//   );
// };

// export default MyDate;
import React from "react";
import DatePicker from "react-datepicker";
import Required from "./Required";
import { Label } from "reactstrap";
import { Controller } from "react-hook-form";
import { get } from "react-hook-form";

const MyDate = ({
  control,
  required,
  disabled,
  time,
  format,
  title,
  name,
  placeholder,
  max,
  min,
  errors,
  year,
  month,
}) => {
  const error = get(errors, name);
  const isYearOnly = year === true;
  const isMonthYear = month === true && !year;
 

  return (
    <div className="form-group my-2">
      <Label htmlFor={name} className="form-label">
        {title}
       {title && required && <Required />}
      </Label>

      <div className="form-control-wrap">
        <Controller
          name={name}
          control={control}
          rules={{
            required: required
              ? `Please select ${title || "this field"}`
              : false,
          }}
          render={({ field }) => (
            <DatePicker
              {...field}
              id={name}
              className={`form-control ${error ? "is-invalid" : ""}`}
              placeholderText={placeholder}
              selected={field.value}
              onChange={(date) => field.onChange(date)}
              dateFormat={
                isYearOnly
                  ? "yyyy"
                  : isMonthYear
                  ? "MM/yyyy"
                  : format || "dd/MM/yyyy"
              }
              showYearPicker={isYearOnly}
              showMonthYearPicker={isMonthYear}
              showMonthDropdown={!isYearOnly && !isMonthYear}
              showYearDropdown={!isYearOnly}
              scrollableYearDropdown={!isYearOnly}
              dropdownMode="select"
              maxDate={max}
              minDate={min}
              showTimeInput={!isYearOnly && !isMonthYear && time}
              disabled={disabled}
            />
          )}
        />
      </div>

      {error && <p className="invalid">{error.message}</p>}
    </div>
  );
};

export default MyDate;
